import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { BriefcaseIcon, GavelIcon, HomeIcon, UsersIcon, ScrollIcon, StoreIcon, HardHatIcon, HelpCircleIcon, ArrowRightIcon } from 'lucide-react';
import { Container } from '../ui/Container';
import { SectionHeading } from '../ui/SectionHeading';
const cards = [{
  icon: BriefcaseIcon,
  title: 'Business & Commercial',
  problem: 'You need contracts, structures or advice you can act on.',
  examples: ['Reviewing an agreement', 'Setting up or restructuring', 'Buying or selling a business'],
  slug: 'commercial-business-law'
}, {
  icon: GavelIcon,
  title: 'Disputes & Litigation',
  problem: 'A disagreement is escalating and you want it handled properly.',
  examples: ['A demand or claim received', 'A contract breach', 'A partner or supplier dispute'],
  slug: 'dispute-resolution'
}, {
  icon: HomeIcon,
  title: 'Property & Conveyancing',
  problem: 'You are buying, selling, leasing or developing property.',
  examples: ['Contract of sale review', 'Settlement support', 'A lease or boundary issue'],
  slug: 'property-law'
}, {
  icon: UsersIcon,
  title: 'Family Law',
  problem: 'Your family circumstances have changed and you need clarity.',
  examples: ['Separation or divorce', 'Parenting arrangements', 'Property settlement'],
  slug: 'family-law'
}, {
  icon: ScrollIcon,
  title: 'Wills, Estates & Succession',
  problem: 'You want to protect your estate, family or business.',
  examples: ['Making or updating a will', 'Applying for probate', 'Planning succession'],
  slug: 'wills-estates'
}, {
  icon: StoreIcon,
  title: 'Franchising',
  problem: 'You are entering or managing a franchise arrangement.',
  examples: ['Reviewing a franchise agreement', 'Disclosure documents', 'Franchisor obligations'],
  slug: 'franchising'
}, {
  icon: HardHatIcon,
  title: 'Employment & Workplace',
  problem: 'A workplace issue needs to be resolved correctly.',
  examples: ['Employment contracts', 'A workplace dispute', 'Restraints & safety'],
  slug: 'employment'
}, {
  icon: HelpCircleIcon,
  title: 'Not sure where to start?',
  problem: "Tell us what's happened and we'll point you in the right direction.",
  examples: ["We'll match you to the right team", 'No obligation', 'Confidential'],
  slug: 'not-sure'
}];
export function IssueSelector() {
  return <section id="services" className="scroll-mt-24 bg-cream py-16 lg:py-24" data-id="element-184">
      <Container data-id="element-185">
        <SectionHeading align="center" eyebrow="Find your starting point" title="What do you need help with?" intro="Every matter is different. Pick the area closest to your situation — each card explains who it's for and what we can help with." data-id="element-186" />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-187">
          {cards.map((card, i) => {
          const notSure = card.slug === 'not-sure';
          const to = notSure ? '/enquiry' : `/services/${card.slug}`;
          const Icon = card.icon;
          return <motion.div key={card.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.35,
            delay: i % 4 * 0.05
          }} className={'group flex flex-col rounded-xl border p-5 shadow-card transition-all duration-200 hover:-translate-y-0.5 hover:shadow-card-hover ' + (notSure ? 'border-brass/40 bg-navy text-cream' : 'border-navy/10 bg-white')} data-id="element-188">
                <span className={'flex h-11 w-11 items-center justify-center rounded-lg ' + (notSure ? 'bg-cream/10' : 'bg-navy/5')} data-id="element-189">
                  <Icon className={notSure ? 'h-5 w-5 text-brass-light' : 'h-5 w-5 text-brass-dark'} data-id="element-190" />
                </span>
                <h3 className={'mt-4 font-serif text-lg ' + (notSure ? 'text-cream' : 'text-navy')} data-id="element-191">
                  {card.title}
                </h3>
                <p className={'mt-2 text-sm leading-relaxed ' + (notSure ? 'text-cream/70' : 'text-ink/65')} data-id="element-192">
                  {card.problem}
                </p>
                <ul className={'mt-3 space-y-1 text-xs ' + (notSure ? 'text-cream/55' : 'text-ink/50')} data-id="element-193">
                  {card.examples.map(e => <li key={e} className="flex items-center gap-1.5" data-id="element-194">
                      <span className={'h-1 w-1 rounded-full ' + (notSure ? 'bg-brass-light' : 'bg-brass')} data-id="element-195" />
                      {e}
                    </li>)}
                </ul>
                <div className="mt-4 flex items-center justify-between border-t pt-3 text-sm font-medium" data-id="element-196">
                  <Link to={to} className={notSure ? 'text-brass-light hover:text-brass' : 'text-navy hover:text-brass-dark'} data-id="element-197">
                    {notSure ? 'Start here' : 'View service'}
                  </Link>
                  <Link to="/enquiry" className={'inline-flex items-center gap-1 text-xs ' + (notSure ? 'text-cream/70 hover:text-cream' : 'text-ink/45 hover:text-brass-dark')} data-id="element-198">
                    Ask us <ArrowRightIcon className="h-3 w-3" data-id="element-199" />
                  </Link>
                </div>
              </motion.div>;
        })}
        </div>
      </Container>
    </section>;
}